import { OverlayContainer } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { effect, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocalStorageManagementFeature } from '@qtek/core/local-storage-management';
import { AuthUserStore } from '@qtek/libs/auth-user';
import { darkTheme, darkThemeClass } from '../models/theme-management.model';
import { ThemeManagementActions } from '../store/theme-management.actions';
import { ThemeManagementFeature } from '../store/theme-management.reducers';

@Injectable({
  providedIn: 'root',
})
export class ThemeManagementService {
  private readonly overlayContainer = inject(OverlayContainer);
  private readonly document: Document = inject(DOCUMENT);
  private readonly store = inject(Store);
  private readonly authUserStore = inject(AuthUserStore);

  private readonly uiTheme = this.store.selectSignal(
    ThemeManagementFeature.selectUiTheme
  );
  private readonly lsTheme = this.store.selectSignal(
    LocalStorageManagementFeature.selectUiTheme
  );

  constructor() {
    effect(() => {
      const isDark = this.uiTheme() === darkTheme;
      this.document.body.classList.toggle(darkThemeClass, isDark);
      this.overlayContainer
        ?.getContainerElement()
        .classList.toggle(darkThemeClass, isDark);
    });

    effect(() => {
      const preferred = this.authUserStore.theme() || this.lsTheme();
      if (preferred && this.uiTheme() !== preferred) {
        this.store.dispatch(
          ThemeManagementActions.synchronizeTheme({ theme: preferred })
        );
      }
    });
  }
}
